import axios from 'axios'
import { getItem, setItem, removeUserData } from '@/utils/StorageManager'
import SERVICE from '@/utils/servicesUtil'
import config from '@/utils/configUtil'
import Vue from '../../main'

let defaultRootUrl = null
const MSAPIInstance = axios.create({
  headers: {
    'content-Type': 'application/json',
  },
})

config().then((res) => {
  MSAPIInstance.defaults.baseURL = res.VUE_APP_ROOT_MSAPI
  defaultRootUrl = res.VUE_APP_ROOT_MSAPI
})

MSAPIInstance.interceptors.request.use(
  function (config) {
    const accessToken = getItem('accessToken') // store.state.auth.accountId;

    if (accessToken) {
      config.headers.common['Authorization'] = `Bearer ${accessToken}`
    }

    return config
  },

  function (err) {
    return Promise.reject(err)
  },
)

MSAPIInstance.interceptors.response.use(
  function (config) {
    return config
  },
  function (error) {
    let originalRequest = error.config
    const validationToken = `${defaultRootUrl}/${SERVICE.USER}/validation-token`

    // Tratamento padrão de alguns erros de negócio
    if (error.response.status == 400) {
      // 160076 - ORGANIZATION_DOES_NOT_HAVE_AN_ACTIVE_PLAN
      if (error.response.data?.errorCode == 160076) {
        Vue.$router.push({ name: 'manage-balance-plans' })
        Vue.$store.commit('auth/SET_SESSION_ORGANIZATION_WITHOUT_ACTIVE_PLAN')
        return
      }
      // 10041 - USER_DOES_NOT_BELONG_TO_ORGANIZATION
      if (error.response.data?.errorCode == 10041) {
        let dontHasPlan = Vue.$store.state.auth.session.organization.dontHasPlan
        // Regra pra evitar com que fique em loop quando o plano está indisponível
        if (dontHasPlan) Vue.$router.push({ name: 'notAllowed' })
        else Vue.$router.push({ name: 'notAllowed', params: Vue.$route.params })
        return
      }
    }

    if (error.response.status === 401 && originalRequest.url === validationToken) {
      removeUserData()
      router.push('/auth/login')
      return Promise.reject(error)
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      let obj = {
        refreshToken: getItem('refreshToken'),
      }

      if (!obj.refreshToken) {
        removeUserData()
        router.push('/auth/login')
        return Promise.reject(error)
      }

      return MSAPIInstance.post(`${validationToken}`, obj)
        .then((res) => {
          if (res.status === 201) {
            setItem('accessToken', res.data.token)
            return new Promise((resolve, reject) => {
              MSAPIInstance(originalRequest)
                .then((resp) => {
                  resolve(resp)
                })
                .catch((erro) => {
                  reject(erro)
                })
            })
          }
        })
        .catch((err) => {
          return Promise.reject(err)
        })
    }

    // if (error.response.status >= 500 && error.response.status < 600) {
    if (error.response.status >= 500 && error.response.status < 502) {
      let organizationIdQuery = {}
      if (router.currentRoute.params.organizationId) {
        organizationIdQuery.organizationId = router.currentRoute.params.organizationId
      }
      router.push({ name: 'error', query: organizationIdQuery })
    }

    return Promise.reject(error)
  },
)

export default MSAPIInstance
